export default "__VITE_ASSET__D1tJ$Bkm__"